import {createAction} from '@ngrx/store';

export const INIT_SUBSEQUENT_DELIVERIES = createAction('[SUBSEQUENT DELIVERIES] Init');
export const LOAD_SUBSEQUENT_DELIVERIES = createAction('[SUBSEQUENT DELIVERIES] Load');
export const LOAD_SUBSEQUENT_DELIVERIES_COMPLETED = createAction('[SUBSEQUENT DELIVERIES] Load Completed');
export const UPDATE_SUBSEQUENT_DELIVERIES = createAction('[SUBSEQUENT DELIVERIES] Update');
export const DELETE_SUBSEQUENT_DELIVERIES = createAction('[SUBSEQUENT DELIVERIES] Delete');
export const FAIL_SUBSEQUENT_DELIVERIES = createAction('[SUBSEQUENT DELIVERIES] Failed');
